import React from 'react';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import * as PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from  'react-router-dom';
import { connect } from 'react-redux';

import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import iconProgram from '../assets/icon_program_b.png';
import iconComment from '../assets/icon_comment.png';

import CardStatus from './CardStatus';
import { commonStyles, COLORS } from '../styles/styles';

import darkOverlay from '../assets/darkOverlay.svg'

import {selectedProgram} from '../redux/selectors'

import {
 resetUserPrograms
} from '../redux/reducers/userProgramsFull';

import {
  MDBCard,
  MDBCardTitle,
  MDBBtn,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBAnimation
} from "mdbreact";
import placeHolder from '../assets/modPlaceHolder.png'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';
import { STORAGE_LINK } from '../constants';


const ProgrammesCard = ({ classes, rolloutCode, 
  handleImageLoaded,
  imageLoadedNow,isSelected, status, name, description, startDate, dueDate, background, match, getProgram, returnFromProgramCard, ...props}) => (
  <div>

    { props.history.location.pathname!='/home'&& props.history.location.pathname!='/programs' && props.history.location.pathname!='/chooseassessment' && props.history.location.pathname!='/choosetool' && props.history.location.pathname!='/choosesession' ? <MDBCard
    className="card border border-white rounded-0 z-depth-3 d-none d-md-block"
    style={{
      padding:8,
      margin: '0 0px 5px'
    }}
  >
    <div style={{position: 'relative', backgroundColor: '#13A2E0', borderRadius: 8}}>
      <MDBBtn
          floating
          tag='a'
          size='sm'
          className='ml-auto ml-4 '
          action
          style={{position: 'absolute', left: -30, top:30}} 
          onClick={()=>returnFromProgramCard()}
        >
          <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
      </MDBBtn>

      <div class="moduleImg2" style={{position:'unset'}}>
        <img src={background ? STORAGE_LINK+background :  getProgram ? STORAGE_LINK+getProgram.background : null} className="z-depth-0 "
                      alt=""  onLoad={handleImageLoaded}  />
        
      </div>
      <div style={{position:'absolute', right:10, top:10}}>
          <CardStatus className="dark-grey-text" status={status ? status : getProgram ? getProgram.status : null} />
      </div>
      
      <div className="moduleCopy text-white" style={{marginBottom:0, paddingBottom:20}}>
        {/* <div className="programIcon">
          <img src={iconProgram} />
        </div> */}
        <div style={{fontSize: 12}}>
              {rolloutCode ? rolloutCode : getProgram ? getProgram.rolloutCode : null}
          </div>
          <h6>
            {name ? name : getProgram ? getProgram.name : null}
          </h6>
          <div className="copy">
            {description ? description : getProgram ? getProgram.description : null}
          </div>
        </div>
     
    </div> 
    <img src={placeHolder} className="z-depth-0" style={{position:'absolute',top:0,left:0,padding: 0,width: '100%'}} alt=""/>
    <ReactCSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}>{imageLoadedNow && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
            <div style={{position:'absolute', top:"40%", width:'100%'}}>
          <ScaleLoader
           
           height={35}
           width={4}
           radius={2}
           margin='2px'
          color={COLORS.cornerstoneRed}
           loading={true}
         />
         </div>
          </div>}</ReactCSSTransitionGroup></MDBCard> : <MDBCard
    className="card-image border border-white rounded-0 z-depth-3"
    style={{
      padding:8,
      margin: '0 0px 5px'
    }}
  ><div style={{position: 'relative'}}>

      <div class="moduleImg">
        <img src={background ? STORAGE_LINK+background :  getProgram ? STORAGE_LINK+getProgram.background : null} className="z-depth-0 "
                      alt=""  onLoad={handleImageLoaded}  />
      </div>
      <div style={{position:'absolute', right:10, top:10}}>
        <CardStatus className="dark-grey-text" status={status} />
      </div>
      
      <div className="moduleCopy">
        {/* <div className="programIcon">
          <img src={iconProgram} />
        </div> */}
        <div style={{fontSize: 12}}>
            {rolloutCode}
        </div>
        <h6>
          {name}
        </h6>
        <div className="copy" style={{minHeight:42}}>
          {description}
        </div>
      </div>


    </div> 
    <img src={placeHolder} className="z-depth-0" style={{position:'absolute',top:0,left:0,padding: 0,width: '100%'}} alt=""/>

    <ReactCSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}>{imageLoadedNow && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
            <div style={{position:'absolute', top:"40%", width:'100%'}}>
          <ScaleLoader
           
           height={35}
           width={4}
           radius={2}
           margin='2px'
          color={COLORS.cornerstoneRed}
           loading={true}
         />
         </div>
          </div>}</ReactCSSTransitionGroup>

  </MDBCard>
    }
  </div>
);

const styles = () => ({
  ...commonStyles,
  card: {
    borderRadius: 0,
    backgroundSize: 'cover',
    marginLeft: 0,
    marginBottom: 0,
    marginRight: 0,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 15,
    paddingBottom: 15,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    cursor: 'pointer',
    background: 'transparent',
    justifyContent: 'space-between',
    transition: '.2s height ease',
    fontFamily: 'Gotham-Black'
  },
  cardContent: {
    padding: 0,
    margin: 'auto',
    overflow: 'auto',
  },
  cardTitle: {
    color: '#FFF',
    fontSize: 18,
    lineHeight: '20px',
    marginTop: 19,
    marginBottom: 10,
    fontFamily: 'Gotham-Black'
  },
  programDescription: {
    color: '#FFF',
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 400,
    marginTop: 10,
    marginBottom: 17,
  },
});

const mapStateToProps = state => ({
  
  getProgram: selectedProgram(state),
});

const mapDispatchToProps = dispatch => ({
  
  resetUserPrograms: () => dispatch(resetUserPrograms()),
 
});

export default compose(withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('imageLoadedNow', 'toggleImageLoaded', true),
  withHandlers({
    handleImageLoaded: props => () => {
      props.toggleImageLoaded(false)
    },
    returnFromProgramCard: props => ()=>{
     if(props.match.path=='/modules/:programId'){
      props.resetUserPrograms();
      props.history.push('/home'+ props.history.location.search)
     }
     if(props.match.path=='/assessments/:programId'){
      props.resetUserPrograms();
      props.history.push('/chooseassessment')
     }
     if(props.match.path=='/tools/:programId'){
      props.resetUserPrograms();
      props.history.push('/choosetool')
     }
     if(props.match.path=='/sessions/:programId'){
      props.resetUserPrograms();
      props.history.push('/choosesession')
     }
    }
  }),
  lifecycle({
    componentWillMount(){
      
    }
  }),
  withRouter,
  withStyles(styles))(ProgrammesCard);

ProgrammesCard.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isSelected: PropTypes.bool,
  status: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  startDate: PropTypes.string,
  dueDate: PropTypes.string,
};
